import { BOOKING_CALENDAR_COLUMN_WIDTH } from "@ryde/shared";

/** Single course pill height inside a calendar cell (px). */
export const COURSES_CALENDAR_CELL_ITEM_HEIGHT_PX = 45;

/** Bottom select/deselect bar inside a calendar cell (px). */
export const COURSES_CALENDAR_CELL_SELECT_BAR_HEIGHT_PX = 20;

/** Inset padding around cell content so hour cells do not visually merge (px). */
export const COURSES_CALENDAR_CELL_OUTER_PADDING_PX = 3;

/** Vertical padding inside a calendar hour cell (px). */
export const COURSES_CALENDAR_CELL_VERTICAL_PADDING_PX = 6;

/** Gap between course pills inside a calendar cell (px). */
export const COURSES_CALENDAR_CELL_ITEM_GAP_PX = 4;

/** Checkbox column width inside a course pill row (px). */
export const COURSES_CALENDAR_CELL_CHECKBOX_WIDTH_PX = 18;

/** Single course row height inside a pill (px). */
export const COURSES_CALENDAR_CELL_ROW_HEIGHT_PX = 30;

/** Full course slots visible in a calendar cell before overflow UI (+N / expand). */
export const COURSES_CALENDAR_CELL_VISIBLE_SLOT_COUNT = 2;

/** Expanded cell popper max height (px). */
export const COURSES_CALENDAR_CELL_EXPAND_POPPER_MAX_HEIGHT_PX = 480;

/** Frozen hour column (checkbox + time label) width (px). */
export const COURSES_CALENDAR_HOUR_COLUMN_WIDTH_PX = 109;

/** Data row height: outer inset + two full slots + inner padding (footer overlays, px). */
export const CALENDAR_HOUR_ROW_HEIGHT_PX =
  COURSES_CALENDAR_CELL_OUTER_PADDING_PX * 2 +
  COURSES_CALENDAR_CELL_VISIBLE_SLOT_COUNT *
    COURSES_CALENDAR_CELL_ITEM_HEIGHT_PX +
  (COURSES_CALENDAR_CELL_VISIBLE_SLOT_COUNT - 1) *
    COURSES_CALENDAR_CELL_ITEM_GAP_PX +
  COURSES_CALENDAR_CELL_VERTICAL_PADDING_PX;

/** `parseInt` radix when reading the hour segment from `timeLabel`. */
export const CALENDAR_TIME_PARSE_RADIX = 10;

/** Zero-pad width for left-column hour labels (e.g. `03`). */
export const CALENDAR_HOUR_LABEL_PAD_LENGTH = 2;

/** Percent added to booking calendar default column width for course calendar day columns. */
export const COURSES_CALENDAR_COLUMN_WIDTH_EXTRA_PERCENT = 34;

export const COURSES_CALENDAR_COLUMN_WIDTH_PX = Math.round(
  (BOOKING_CALENDAR_COLUMN_WIDTH *
    (100 + COURSES_CALENDAR_COLUMN_WIDTH_EXTRA_PERCENT)) /
    100,
);

/** Inner cell width aligned with booking calendar day columns (px). */
export const COURSES_CALENDAR_CELL_WIDTH_PX = BOOKING_CALENDAR_COLUMN_WIDTH;

/** Expanded cell popper width (px). */
export const COURSES_CALENDAR_CELL_EXPAND_POPPER_WIDTH_PX =
  COURSES_CALENDAR_COLUMN_WIDTH_PX + 40;

/** Subtracted from `100vh` for the calendar outer container `height` (layout chrome, px). */
export const CALENDAR_OUTER_VIEWPORT_OFFSET_PX = 188;

/** Minimum height of the calendar outer container (px). */
export const CALENDAR_OUTER_MIN_HEIGHT_PX = 400;
